import { useEffect, useState } from "react";
import { SummaryWrapper } from "../SummaryWrapper";

interface ProductSummaryProps {
  coverInformation: Record<string, unknown>;
  insurerLogo: string;
  productName: string;
  policyStartDate?: string;
  totalGrossPremium?: string;
  hasSharedLimits?: boolean;
  hasPrimaryCover?: boolean;
}

interface PersistentProductSummaryProps {
  productSummary: ProductSummaryProps[];
  expandCover?: boolean;
  mobileView: boolean;
  applicationDashboard?: boolean;
  updateApplicationDashboard?: (response: unknown) => void;
  isOnlyProduct: boolean;
}

export const PersistentProductSummary = ({
  productSummary,
  expandCover,
  mobileView,
  applicationDashboard = false,
  updateApplicationDashboard,
  isOnlyProduct,
}: PersistentProductSummaryProps) => {
  const [isUpsell, setIsUpsell] = useState(false);

  useEffect(() => {
    setIsUpsell(document.getElementsByClassName("upsell-question").length > 0);
  }, []);
  if (!Array.isArray(productSummary)) {
    return null;
  }
  return (
    <div className="persistent_product_summary mobius-payment-summary__persistent-product-summary-div">
      {productSummary.map((product, idx) => (
        <SummaryWrapper
          key={`${idx}_${product.insurerLogo}`}
          productName={product.productName}
          productSummary={product.coverInformation}
          policyStartDate={product.policyStartDate}
          totalGrossPremium={product.totalGrossPremium}
          hasSharedLimits={product.hasSharedLimits}
          hasPrimaryCover={product.hasPrimaryCover}
          insurerLogo={product.insurerLogo}
          expandCover={isUpsell && expandCover}
          mobileView={mobileView}
          applicationDashboard={applicationDashboard}
          updateApplicationDashboard={updateApplicationDashboard}
          isOnlyProduct={isOnlyProduct}
          onUpdateItem={(): void => {}}
        />
      ))}
    </div>
  );
};
